<template>
  <v-row class="d-flex">
    <v-col sm="4">
      <ItemListCard cardTitle="Drogas" :listItems="drugs" />
    </v-col>
    <v-col sm="4">
      <ItemListCard cardTitle="Choques" :listItems="shocks" />
    </v-col>
    <v-col sm="4">
      <ItemListCard cardTitle="Outros" :listItems="other" />
    </v-col>
    <v-col sm="4">
      <ItemListCard cardTitle="Via aérea avançada" :listItems="advancedAirways" />
    </v-col>
  </v-row>
</template>

<script>
import ItemListCard from "@/components/molecules/Procedimento/item-list-card";
export default {
  components: {
    ItemListCard
  },
  data() {
    return {
      drugs: [
        {
          name: "Adrenalina",
          value: 1350
        },
        {
          name: "Amiodarona",
          value: 359
        },
        {
          name: "Lidocaína",
          value: 673
        },
        {
          name: "Atropina",
          value: 112
        }
      ],
      shocks: [
        {
          name: "Fibrilação Ventricular",
          value: 3234
        },
        {
          name: "Taquicardia Ventricular",
          value: 1359
        }
      ],
      other: [
        {
          name: "Assistolia",
          value: 897
        },
        {
          name: "OVACE",
          value: 1352
        },
        {
          name: "AESP",
          value: 332
        }
      ],
      advancedAirways: [
        {
          name: "Confirmada",
          value: 272
        },
        {
          name: "Esofágica",
          value: 112
        },
        {
          name: "Orotraqueal",
          value: 86
        }
      ]
    };
  },
  beforeMount() {
    this.drugs = this.$store.getters.drugsCounter;
    this.shocks = this.$store.getters.shocksCounter;
    this.advancedAirways = this.$store.getters.advancedAirwaysCounter;
    this.other = this.$store.getters.otherCounter;
  }
};
</script>

<style scoped>
</style>